import * as React from 'react';
import { capitalize } from '../../../../../../shared/StringExtensions';
import { IOrderListItem } from '../../../../Entities';
import OrderList from './OrderList';
import { Collapse, Button, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

type OrderListSectionProps = {
    title: string;
    isOpen: boolean;
    setIsOpen: () => void;
    orders: IOrderListItem[];
    user: any;
    navigateTo: (route: string) => void;
    newOrderId: number | null;
};

function OrderListSection({ 
    title, 
    isOpen, 
    setIsOpen,
    orders, 
    user, 
    navigateTo, 
    newOrderId
}: OrderListSectionProps) {
    return (
        <div className="orderCollectionSection__container">
            <Button
                className="orderCollectionSection__headingToggleButton"
                onClick={() => setIsOpen()}
                sx={{ textTransform: 'none', justifyContent: 'flex-start' }}
            >
                <div className="orderCollectionSection__headerContainer">
                    <Typography variant="h5" component="h2">
                        {capitalize(title)}
                    </Typography>
                    {isOpen ? (
                        <ExpandMoreIcon className="orderCollectionSection__expandCollapseIcon" />
                    ) : (
                        <ExpandLessIcon className="orderCollectionSection__expandCollapseIcon" />
                    )}
                </div>
            </Button>
            <Collapse in={isOpen} unmountOnExit>
                <OrderList 
                    orders={orders} 
                    user={user} 
                    navigateTo={navigateTo} 
                    newOrderId={newOrderId} 
                />
            </Collapse>
        </div>
    );
}

export default OrderListSection;